
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.984 17.727a1.931 1.931 0 01-1.97-1.9 1.933 1.933 0 011.902-1.967l3.546-.062c.421 0 .833-.124 1.184-.357a1.934 1.934 0 112.173 3.2 6.017 6.017 0 01-3.29 1.024l-3.545.062zM18.227 19.6a1.934 1.934 0 002.735-.048l2.657-2.752a1.933 1.933 0 00-.047-2.735l-2.752-2.657a1.934 1.934 0 00-3.103 2.193l-.59.01c-.822.015-1.48-.35-1.904-1.055l-3.653-6.08a5.948 5.948 0 00-5.287-2.93l-3.546.061a1.934 1.934 0 00.068 3.867l3.546-.062c.822-.014 1.48.35 1.904 1.056l3.653 6.08a5.947 5.947 0 005.287 2.93l.59-.01a1.934 1.934 0 00.442 2.132zm2.556-10.3l2.657-2.753a1.934 1.934 0 00-.047-2.734L20.64 1.155a1.934 1.934 0 00-3.103 2.194l-.59.01a6.018 6.018 0 00-3.289 1.024 1.934 1.934 0 002.173 3.2c.351-.233.763-.358 1.184-.357l.59-.01A1.934 1.934 0 0020.782 9.3z","fill":"#ABAFB5"}})])
          )
        }
      }
    